import { Rings } from 'react-loader-spinner';
import { LoaderBackdrop, LoaderWrap } from './Loader.styled';

export const Loader = () => {
  return (
    <LoaderBackdrop>
      <LoaderWrap>
        <Rings
          height="80"
          width="80"
          color="#FF7601"
          secondaryColor="#FF7601"
          radius="6"
          ariaLabel="rings-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </LoaderWrap>
    </LoaderBackdrop>
  );
};
